module.exports = __webpack_public_path__ + "img-blockchain@3x--07671e2b.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/authenticity/img-blockchain@3x.png
// module id = 121
// module chunks = 0